export default __webpack_public_path__ + "static/media/logo.b2e5a01e.svg";